export class BdUserConsent {
  public consent: {
    linkedIn: boolean;
    youtube: boolean;
    zendesk: boolean;
    tracking: boolean;
  };

  constructor(consent: {
    linkedIn: boolean;
    youtube: boolean;
    zendesk: boolean;
    tracking: boolean;
  }) {
    this.consent = consent;
  }

  public consentForMarketing(): boolean {
    return this.consent.linkedIn && this.consent.youtube;
  }

  public equals(other: BdUserConsent): boolean {
    return (
      this.consent.zendesk === other.consent.zendesk &&
      this.consent.tracking === other.consent.tracking &&
      this.consent.linkedIn === other.consent.linkedIn &&
      this.consent.youtube === other.consent.youtube
    );
  }
}

export const BD_USER_CONSENT_ALL_FALSE: BdUserConsent = new BdUserConsent({
  linkedIn: false,
  youtube: false,
  tracking: false,
  zendesk: true,
});
